import { Select } from "antd";
import React from "react";

export const CountryCodesSelect = (props) => {
  const handleCountryChange = (value, option) => {
    props.setSelectedCountryCode(option.code);
    if (props.setSelectedPhoneEx) {
      props.setSelectedPhoneEx(option.phoneEx);
    }

    props.setSelectedCountry(value.value);
  };

  return (
    <>
      <Select
        defaultValue={props.defaultCountry}
        showSearch
        labelInValue
        onChange={handleCountryChange}
        style={{
          width: "100%",
        }}
        placeholder="Search to Select"
        optionFilterProp="children"
        filterOption={(input, option) => (option?.value ?? "").includes(input)}
        filterSort={(optionA, optionB) =>
          (optionA?.value ?? "")
            .toLowerCase()
            .localeCompare((optionB?.value ?? "").toLowerCase())
        }
        options={countries}
      />
    </>
  );
};

export const countries = [
  {
    value: "Afghanistan",
    phoneEx: "+93",
    code: "AF",
  },
  {
    value: "Aland Islands",
    phoneEx: "+358",
    code: "AX",
  },
  {
    value: "Albania",
    phoneEx: "+355",
    code: "AL",
  },
  {
    value: "Algeria",
    phoneEx: "+213",
    code: "DZ",
  },
  {
    value: "AmericanSamoa",
    phoneEx: "+1684",
    code: "AS",
  },
  {
    value: "Andorra",
    phoneEx: "+376",
    code: "AD",
  },
  {
    value: "Angola",
    phoneEx: "+244",
    code: "AO",
  },
  {
    value: "Anguilla",
    phoneEx: "+1264",
    code: "AI",
  },
  {
    value: "Antarctica",
    phoneEx: "+672",
    code: "AQ",
  },
  {
    value: "Antigua and Barbuda",
    phoneEx: "+1268",
    code: "AG",
  },
  {
    value: "Argentina",
    phoneEx: "+54",
    code: "AR",
  },
  {
    value: "Armenia",
    phoneEx: "+374",
    code: "AM",
  },
  {
    value: "Aruba",
    phoneEx: "+297",
    code: "AW",
  },
  {
    value: "Australia",
    phoneEx: "+61",
    code: "AU",
  },
  {
    value: "Austria",
    phoneEx: "+43",
    code: "AT",
  },
  {
    value: "Azerbaijan",
    phoneEx: "+994",
    code: "AZ",
  },
  {
    value: "Bahamas",
    phoneEx: "+1242",
    code: "BS",
  },
  {
    value: "Bahrain",
    phoneEx: "+973",
    code: "BH",
  },
  {
    value: "Bangladesh",
    phoneEx: "+880",
    code: "BD",
  },
  {
    value: "Barbados",
    phoneEx: "+1246",
    code: "BB",
  },
  {
    value: "Belarus",
    phoneEx: "+375",
    code: "BY",
  },
  {
    value: "Belgium",
    phoneEx: "+32",
    code: "BE",
  },
  {
    value: "Belize",
    phoneEx: "+501",
    code: "BZ",
  },
  {
    value: "Benin",
    phoneEx: "+229",
    code: "BJ",
  },
  {
    value: "Bermuda",
    phoneEx: "+1441",
    code: "BM",
  },
  {
    value: "Bhutan",
    phoneEx: "+975",
    code: "BT",
  },
  {
    value: "Bolivia, Plurinational State of",
    phoneEx: "+591",
    code: "BO",
  },
  {
    value: "Bosnia and Herzegovina",
    phoneEx: "+387",
    code: "BA",
  },
  {
    value: "Botswana",
    phoneEx: "+267",
    code: "BW",
  },
  {
    value: "Brazil",
    phoneEx: "+55",
    code: "BR",
  },
  {
    value: "British Indian Ocean Territory",
    phoneEx: "+246",
    code: "IO",
  },
  {
    value: "Brunei Darussalam",
    phoneEx: "+673",
    code: "BN",
  },
  {
    value: "Bulgaria",
    phoneEx: "+359",
    code: "BG",
  },
  {
    value: "Burkina Faso",
    phoneEx: "+226",
    code: "BF",
  },
  {
    value: "Burundi",
    phoneEx: "+257",
    code: "BI",
  },
  {
    value: "Cambodia",
    phoneEx: "+855",
    code: "KH",
  },
  {
    value: "Cameroon",
    phoneEx: "+237",
    code: "CM",
  },
  {
    value: "Canada",
    phoneEx: "+1",
    code: "CA",
  },
  {
    value: "Cape Verde",
    phoneEx: "+238",
    code: "CV",
  },
  {
    value: "Cayman Islands",
    phoneEx: "+ 345",
    code: "KY",
  },
  {
    value: "Central African Republic",
    phoneEx: "+236",
    code: "CF",
  },
  {
    value: "Chad",
    phoneEx: "+235",
    code: "TD",
  },
  {
    value: "Chile",
    phoneEx: "+56",
    code: "CL",
  },
  {
    value: "China",
    phoneEx: "+86",
    code: "CN",
  },
  {
    value: "Christmas Island",
    phoneEx: "+61",
    code: "CX",
  },
  {
    value: "Cocos (Keeling) Islands",
    phoneEx: "+61",
    code: "CC",
  },
  {
    value: "Colombia",
    phoneEx: "+57",
    code: "CO",
  },
  {
    value: "Comoros",
    phoneEx: "+269",
    code: "KM",
  },
  {
    value: "Congo",
    phoneEx: "+242",
    code: "CG",
  },
  {
    value: "Congo, The Democratic Republic of the Congo",
    phoneEx: "+243",
    code: "CD",
  },
  {
    value: "Cook Islands",
    phoneEx: "+682",
    code: "CK",
  },
  {
    value: "Costa Rica",
    phoneEx: "+506",
    code: "CR",
  },
  {
    value: "Cote d'Ivoire",
    phoneEx: "+225",
    code: "CI",
  },
  {
    value: "Croatia",
    phoneEx: "+385",
    code: "HR",
  },
  {
    value: "Cuba",
    phoneEx: "+53",
    code: "CU",
  },
  {
    value: "Cyprus",
    phoneEx: "+357",
    code: "CY",
  },
  {
    value: "Czech Republic",
    phoneEx: "+420",
    code: "CZ",
  },
  {
    value: "Denmark",
    phoneEx: "+45",
    code: "DK",
  },
  {
    value: "Djibouti",
    phoneEx: "+253",
    code: "DJ",
  },
  {
    value: "Dominica",
    phoneEx: "+1767",
    code: "DM",
  },
  {
    value: "Dominican Republic",
    phoneEx: "+1849",
    code: "DO",
  },
  {
    value: "Ecuador",
    phoneEx: "+593",
    code: "EC",
  },
  {
    value: "Egypt",
    phoneEx: "+20",
    code: "EG",
  },
  {
    value: "El Salvador",
    phoneEx: "+503",
    code: "SV",
  },
  {
    value: "Equatorial Guinea",
    phoneEx: "+240",
    code: "GQ",
  },
  {
    value: "Eritrea",
    phoneEx: "+291",
    code: "ER",
  },
  {
    value: "Estonia",
    phoneEx: "+372",
    code: "EE",
  },
  {
    value: "Ethiopia",
    phoneEx: "+251",
    code: "ET",
  },
  {
    value: "Falkland Islands (Malvinas)",
    phoneEx: "+500",
    code: "FK",
  },
  {
    value: "Faroe Islands",
    phoneEx: "+298",
    code: "FO",
  },
  {
    value: "Fiji",
    phoneEx: "+679",
    code: "FJ",
  },
  {
    value: "Finland",
    phoneEx: "+358",
    code: "FI",
  },
  {
    value: "France",
    phoneEx: "+33",
    code: "FR",
  },
  {
    value: "French Guiana",
    phoneEx: "+594",
    code: "GF",
  },
  {
    value: "French Polynesia",
    phoneEx: "+689",
    code: "PF",
  },
  {
    value: "Gabon",
    phoneEx: "+241",
    code: "GA",
  },
  {
    value: "Gambia",
    phoneEx: "+220",
    code: "GM",
  },
  {
    value: "Georgia",
    phoneEx: "+995",
    code: "GE",
  },
  {
    value: "Germany",
    phoneEx: "+49",
    code: "DE",
  },
  {
    value: "Ghana",
    phoneEx: "+233",
    code: "GH",
  },
  {
    value: "Gibraltar",
    phoneEx: "+350",
    code: "GI",
  },
  {
    value: "Greece",
    phoneEx: "+30",
    code: "GR",
  },
  {
    value: "Greenland",
    phoneEx: "+299",
    code: "GL",
  },
  {
    value: "Grenada",
    phoneEx: "+1473",
    code: "GD",
  },
  {
    value: "Guadeloupe",
    phoneEx: "+590",
    code: "GP",
  },
  {
    value: "Guam",
    phoneEx: "+1671",
    code: "GU",
  },
  {
    value: "Guatemala",
    phoneEx: "+502",
    code: "GT",
  },
  {
    value: "Guernsey",
    phoneEx: "+44",
    code: "GG",
  },
  {
    value: "Guinea",
    phoneEx: "+224",
    code: "GN",
  },
  {
    value: "Guinea-Bissau",
    phoneEx: "+245",
    code: "GW",
  },
  {
    value: "Guyana",
    phoneEx: "+595",
    code: "GY",
  },
  {
    value: "Haiti",
    phoneEx: "+509",
    code: "HT",
  },
  {
    value: "Holy See (Vatican City State)",
    phoneEx: "+379",
    code: "VA",
  },
  {
    value: "Honduras",
    phoneEx: "+504",
    code: "HN",
  },
  {
    value: "Hong Kong",
    phoneEx: "+852",
    code: "HK",
  },
  {
    value: "Hungary",
    phoneEx: "+36",
    code: "HU",
  },
  {
    value: "Iceland",
    phoneEx: "+354",
    code: "IS",
  },
  {
    value: "India",
    phoneEx: "+91",
    code: "IN",
  },
  {
    value: "Indonesia",
    phoneEx: "+62",
    code: "ID",
  },
  {
    value: "Iran, Islamic Republic of Persian Gulf",
    phoneEx: "+98",
    code: "IR",
  },
  {
    value: "Iraq",
    phoneEx: "+964",
    code: "IQ",
  },
  {
    value: "Ireland",
    phoneEx: "+353",
    code: "IE",
  },
  {
    value: "Isle of Man",
    phoneEx: "+44",
    code: "IM",
  },
  {
    value: "Israel",
    phoneEx: "+972",
    code: "IL",
  },
  {
    value: "Italy",
    phoneEx: "+39",
    code: "IT",
  },
  {
    value: "Jamaica",
    phoneEx: "+1876",
    code: "JM",
  },
  {
    value: "Japan",
    phoneEx: "+81",
    code: "JP",
  },
  {
    value: "Jersey",
    phoneEx: "+44",
    code: "JE",
  },
  {
    value: "Jordan",
    phoneEx: "+962",
    code: "JO",
  },
  {
    value: "Kazakhstan",
    phoneEx: "+77",
    code: "KZ",
  },
  {
    value: "Kenya",
    phoneEx: "+254",
    code: "KE",
  },
  {
    value: "Kiribati",
    phoneEx: "+686",
    code: "KI",
  },
  {
    value: "Korea, Democratic People's Republic of Korea",
    phoneEx: "+850",
    code: "KP",
  },
  {
    value: "Korea, Republic of South Korea",
    phoneEx: "+82",
    code: "KR",
  },
  {
    value: "Kuwait",
    phoneEx: "+965",
    code: "KW",
  },
  {
    value: "Kyrgyzstan",
    phoneEx: "+996",
    code: "KG",
  },
  {
    value: "Laos",
    phoneEx: "+856",
    code: "LA",
  },
  {
    value: "Latvia",
    phoneEx: "+371",
    code: "LV",
  },
  {
    value: "Lebanon",
    phoneEx: "+961",
    code: "LB",
  },
  {
    value: "Lesotho",
    phoneEx: "+266",
    code: "LS",
  },
  {
    value: "Liberia",
    phoneEx: "+231",
    code: "LR",
  },
  {
    value: "Libyan Arab Jamahiriya",
    phoneEx: "+218",
    code: "LY",
  },
  {
    value: "Liechtenstein",
    phoneEx: "+423",
    code: "LI",
  },
  {
    value: "Lithuania",
    phoneEx: "+370",
    code: "LT",
  },
  {
    value: "Luxembourg",
    phoneEx: "+352",
    code: "LU",
  },
  {
    value: "Macao",
    phoneEx: "+853",
    code: "MO",
  },
  {
    value: "Macedonia",
    phoneEx: "+389",
    code: "MK",
  },
  {
    value: "Madagascar",
    phoneEx: "+261",
    code: "MG",
  },
  {
    value: "Malawi",
    phoneEx: "+265",
    code: "MW",
  },
  {
    value: "Malaysia",
    phoneEx: "+60",
    code: "MY",
  },
  {
    value: "Maldives",
    phoneEx: "+960",
    code: "MV",
  },
  {
    value: "Mali",
    phoneEx: "+223",
    code: "ML",
  },
  {
    value: "Malta",
    phoneEx: "+356",
    code: "MT",
  },
  {
    value: "Marshall Islands",
    phoneEx: "+692",
    code: "MH",
  },
  {
    value: "Martinique",
    phoneEx: "+596",
    code: "MQ",
  },
  {
    value: "Mauritania",
    phoneEx: "+222",
    code: "MR",
  },
  {
    value: "Mauritius",
    phoneEx: "+230",
    code: "MU",
  },
  {
    value: "Mayotte",
    phoneEx: "+262",
    code: "YT",
  },
  {
    value: "Mexico",
    phoneEx: "+52",
    code: "MX",
  },
  {
    value: "Micronesia, Federated States of Micronesia",
    phoneEx: "+691",
    code: "FM",
  },
  {
    value: "Moldova",
    phoneEx: "+373",
    code: "MD",
  },
  {
    value: "Monaco",
    phoneEx: "+377",
    code: "MC",
  },
  {
    value: "Mongolia",
    phoneEx: "+976",
    code: "MN",
  },
  {
    value: "Montenegro",
    phoneEx: "+382",
    code: "ME",
  },
  {
    value: "Montserrat",
    phoneEx: "+1664",
    code: "MS",
  },
  {
    value: "Morocco",
    phoneEx: "+212",
    code: "MA",
  },
  {
    value: "Mozambique",
    phoneEx: "+258",
    code: "MZ",
  },
  {
    value: "Myanmar",
    phoneEx: "+95",
    code: "MM",
  },
  {
    value: "Namibia",
    phoneEx: "+264",
    code: "NA",
  },
  {
    value: "Nauru",
    phoneEx: "+674",
    code: "NR",
  },
  {
    value: "Nepal",
    phoneEx: "+977",
    code: "NP",
  },
  {
    value: "Netherlands",
    phoneEx: "+31",
    code: "NL",
  },
  {
    value: "Netherlands Antilles",
    phoneEx: "+599",
    code: "AN",
  },
  {
    value: "New Caledonia",
    phoneEx: "+687",
    code: "NC",
  },
  {
    value: "New Zealand",
    phoneEx: "+64",
    code: "NZ",
  },
  {
    value: "Nicaragua",
    phoneEx: "+505",
    code: "NI",
  },
  {
    value: "Niger",
    phoneEx: "+227",
    code: "NE",
  },
  {
    value: "Nigeria",
    phoneEx: "+234",
    code: "NG",
  },
  {
    value: "Niue",
    phoneEx: "+683",
    code: "NU",
  },
  {
    value: "Norfolk Island",
    phoneEx: "+672",
    code: "NF",
  },
  {
    value: "Northern Mariana Islands",
    phoneEx: "+1670",
    code: "MP",
  },
  {
    value: "Norway",
    phoneEx: "+47",
    code: "NO",
  },
  {
    value: "Oman",
    phoneEx: "+968",
    code: "OM",
  },
  {
    value: "Pakistan",
    phoneEx: "+92",
    code: "PK",
  },
  {
    value: "Palau",
    phoneEx: "+680",
    code: "PW",
  },
  {
    value: "Palestinian Territory, Occupied",
    phoneEx: "+970",
    code: "PS",
  },
  {
    value: "Panama",
    phoneEx: "+507",
    code: "PA",
  },
  {
    value: "Papua New Guinea",
    phoneEx: "+675",
    code: "PG",
  },
  {
    value: "Paraguay",
    phoneEx: "+595",
    code: "PY",
  },
  {
    value: "Peru",
    phoneEx: "+51",
    code: "PE",
  },
  {
    value: "Philippines",
    phoneEx: "+63",
    code: "PH",
  },
  {
    value: "Pitcairn",
    phoneEx: "+872",
    code: "PN",
  },
  {
    value: "Poland",
    phoneEx: "+48",
    code: "PL",
  },
  {
    value: "Portugal",
    phoneEx: "+351",
    code: "PT",
  },
  {
    value: "Puerto Rico",
    phoneEx: "+1939",
    code: "PR",
  },
  {
    value: "Qatar",
    phoneEx: "+974",
    code: "QA",
  },
  {
    value: "Romania",
    phoneEx: "+40",
    code: "RO",
  },
  {
    value: "Russia",
    phoneEx: "+7",
    code: "RU",
  },
  {
    value: "Rwanda",
    phoneEx: "+250",
    code: "RW",
  },
  {
    value: "Reunion",
    phoneEx: "+262",
    code: "RE",
  },
  {
    value: "Saint Barthelemy",
    phoneEx: "+590",
    code: "BL",
  },
  {
    value: "Saint Helena, Ascension and Tristan Da Cunha",
    phoneEx: "+290",
    code: "SH",
  },
  {
    value: "Saint Kitts and Nevis",
    phoneEx: "+1869",
    code: "KN",
  },
  {
    value: "Saint Lucia",
    phoneEx: "+1758",
    code: "LC",
  },
  {
    value: "Saint Martin",
    phoneEx: "+590",
    code: "MF",
  },
  {
    value: "Saint Pierre and Miquelon",
    phoneEx: "+508",
    code: "PM",
  },
  {
    value: "Saint Vincent and the Grenadines",
    phoneEx: "+1784",
    code: "VC",
  },
  {
    value: "Samoa",
    phoneEx: "+685",
    code: "WS",
  },
  {
    value: "San Marino",
    phoneEx: "+378",
    code: "SM",
  },
  {
    value: "Sao Tome and Principe",
    phoneEx: "+239",
    code: "ST",
  },
  {
    value: "Saudi Arabia",
    phoneEx: "+966",
    code: "SA",
  },
  {
    value: "Senegal",
    phoneEx: "+221",
    code: "SN",
  },
  {
    value: "Serbia",
    phoneEx: "+381",
    code: "RS",
  },
  {
    value: "Seychelles",
    phoneEx: "+248",
    code: "SC",
  },
  {
    value: "Sierra Leone",
    phoneEx: "+232",
    code: "SL",
  },
  {
    value: "Singapore",
    phoneEx: "+65",
    code: "SG",
  },
  {
    value: "Slovakia",
    phoneEx: "+421",
    code: "SK",
  },
  {
    value: "Slovenia",
    phoneEx: "+386",
    code: "SI",
  },
  {
    value: "Solomon Islands",
    phoneEx: "+677",
    code: "SB",
  },
  {
    value: "Somalia",
    phoneEx: "+252",
    code: "SO",
  },
  {
    value: "South Africa",
    phoneEx: "+27",
    code: "ZA",
  },
  {
    value: "South Sudan",
    phoneEx: "+211",
    code: "SS",
  },
  {
    value: "South Georgia and the South Sandwich Islands",
    phoneEx: "+500",
    code: "GS",
  },
  {
    value: "Spain",
    phoneEx: "+34",
    code: "ES",
  },
  {
    value: "Sri Lanka",
    phoneEx: "+94",
    code: "LK",
  },
  {
    value: "Sudan",
    phoneEx: "+249",
    code: "SD",
  },
  {
    value: "Surivalue",
    phoneEx: "+597",
    code: "SR",
  },
  {
    value: "Svalbard and Jan Mayen",
    phoneEx: "+47",
    code: "SJ",
  },
  {
    value: "Swaziland",
    phoneEx: "+268",
    code: "SZ",
  },
  {
    value: "Sweden",
    phoneEx: "+46",
    code: "SE",
  },
  {
    value: "Switzerland",
    phoneEx: "+41",
    code: "CH",
  },
  {
    value: "Syrian Arab Republic",
    phoneEx: "+963",
    code: "SY",
  },
  {
    value: "Taiwan",
    phoneEx: "+886",
    code: "TW",
  },
  {
    value: "Tajikistan",
    phoneEx: "+992",
    code: "TJ",
  },
  {
    value: "Tanzania, United Republic of Tanzania",
    phoneEx: "+255",
    code: "TZ",
  },
  {
    value: "Thailand",
    phoneEx: "+66",
    code: "TH",
  },
  {
    value: "Timor-Leste",
    phoneEx: "+670",
    code: "TL",
  },
  {
    value: "Togo",
    phoneEx: "+228",
    code: "TG",
  },
  {
    value: "Tokelau",
    phoneEx: "+690",
    code: "TK",
  },
  {
    value: "Tonga",
    phoneEx: "+676",
    code: "TO",
  },
  {
    value: "Trinidad and Tobago",
    phoneEx: "+1868",
    code: "TT",
  },
  {
    value: "Tunisia",
    phoneEx: "+216",
    code: "TN",
  },
  {
    value: "Turkey",
    phoneEx: "+90",
    code: "TR",
  },
  {
    value: "Turkmenistan",
    phoneEx: "+993",
    code: "TM",
  },
  {
    value: "Turks and Caicos Islands",
    phoneEx: "+1649",
    code: "TC",
  },
  {
    value: "Tuvalu",
    phoneEx: "+688",
    code: "TV",
  },
  {
    value: "Uganda",
    phoneEx: "+256",
    code: "UG",
  },
  {
    value: "Ukraine",
    phoneEx: "+380",
    code: "UA",
  },
  {
    value: "United Arab Emirates",
    phoneEx: "+971",
    code: "AE",
  },
  {
    value: "United Kingdom",
    phoneEx: "+44",
    code: "GB",
  },
  {
    value: "United States",
    phoneEx: "+1",
    code: "US",
  },
  {
    value: "Uruguay",
    phoneEx: "+598",
    code: "UY",
  },
  {
    value: "Uzbekistan",
    phoneEx: "+998",
    code: "UZ",
  },
  {
    value: "Vanuatu",
    phoneEx: "+678",
    code: "VU",
  },
  {
    value: "Venezuela, Bolivarian Republic of Venezuela",
    phoneEx: "+58",
    code: "VE",
  },
  {
    value: "Vietnam",
    phoneEx: "+84",
    code: "VN",
  },
  {
    value: "Virgin Islands, British",
    phoneEx: "+1284",
    code: "VG",
  },
  {
    value: "Virgin Islands, U.S.",
    phoneEx: "+1340",
    code: "VI",
  },
  {
    value: "Wallis and Futuna",
    phoneEx: "+681",
    code: "WF",
  },
  {
    value: "Yemen",
    phoneEx: "+967",
    code: "YE",
  },
  {
    value: "Zambia",
    phoneEx: "+260",
    code: "ZM",
  },
  {
    value: "Zimbabwe",
    phoneEx: "+263",
    code: "ZW",
  },
];
